import styled from "styled-components";

export const NumberFormatterInputStyles = styled.div`
  width: 100%;

  .input {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    box-sizing: border-box;
    border-radius: ${({ theme }) => theme.radius[4]};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    padding: ${({ theme }) => theme.spacing[8]};
    width: 100%;
    outline: none;
  }

  .input:focus {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .input::placeholder {
    opacity: 0.5;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }
`;
